// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getMessaging, onMessage } from "firebase/messaging";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyAHgMPz1QPLJCU9TAb9YZiBkYcM4-lqwn4",
//   authDomain: "ponderiee-b6614.firebaseapp.com",
//   projectId: "ponderiee-b6614",
//   storageBucket: "ponderiee-b6614.firebasestorage.app",
//   messagingSenderId: "1043569049337",
//   appId: "1:1043569049337:web:ecc13843ad941ae623ac28",
//   measurementId: "G-M1FVJHE8W8"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);

// export const messaging = getMessaging(app);

// export const listenForNotifications = (callback) => {
//     onMessage(messaging, (payload) => {
//       console.log("Foreground notification received:", payload);
//       const notification = {
//         title: payload.notification?.title || "No Title",
//         body: payload.notification?.body || "No Body",
//         time:payload?.data?.timestamp,
//         link: payload?.data?.ctaUrl || "/",
//       };
  
//       callback(notification);
//     });
//   };


// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, onMessage } from "firebase/messaging";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAHgMPz1QPLJCU9TAb9YZiBkYcM4-lqwn4",
  authDomain: "ponderiee-b6614.firebaseapp.com",
  projectId: "ponderiee-b6614",
  storageBucket: "ponderiee-b6614.firebasestorage.app",
  messagingSenderId: "1043569049337",
  appId: "1:1043569049337:web:ecc13843ad941ae623ac28",
  measurementId: "G-M1FVJHE8W8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

// Original function for foreground notifications only
export const listenForNotifications = (callback) => {
  onMessage(messaging, (payload) => {
    console.log("Foreground notification received:", payload);
    const notification = {
      title: payload.notification?.title || "No Title",
      body: payload.notification?.body || "No Body",
      time: payload?.data?.timestamp,
      link: payload?.data?.ctaUrl || "/",
    };
    callback(notification);
  });
};

// Enhanced function to handle both foreground and background notifications
export const listenForAllNotifications = (callback) => {
  // Handle foreground notifications
  onMessage(messaging, (payload) => {
    console.log("Foreground notification received:", payload);
    const notification = {
      title: payload.notification?.title || "No Title",
      body: payload.notification?.body || "No Body",
      time: payload?.data?.timestamp,
      link: payload?.data?.link || "/",
      source: 'foreground'
    };
    callback(notification);
  });

  // Listen for background notification clicks and data
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'background-notification') {
        console.log('Background notification data received:', event.data.payload);
        
        // Format the background notification data consistently
        const notification = {
          title: event.data.payload.notification?.title || "No Title",
          body: event.data.payload.notification?.body || "No Body",
          time: event.data.payload.data?.timestamp,
          link: event.data.payload.data?.ctaUrl || "/",
          source: 'background'
        };
        callback(notification);
      }
    });
  }
};